import { features } from "@/mocks/homeData";

export default function Features() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            为什么选择必赢亚洲
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            六大核心优势，为您打造极致娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="group bg-background-100 rounded-lg p-6 border border-background-200/70 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}